(function ($) {
    let $fn = $(".comp_visual_small");

    if ($fn.length) {
        cssLoaded(function() {
            $fn.find(".wrp_comp_caption .elm_item").first().addClass("is-selected");
        })
    }
})(jQuery);